module.exports = __webpack_public_path__ + "static/media/next-icon-stir-stick-o.680b4e35.svg";